import React from 'react'
import { type IScheduleDateFiledUIProps, ScheduleDelayUI } from './ui/ScheduleDelayUI'
import { ScheduleDelayContext } from './context/sendLaterContext'
import { type ScheduleDelayStore } from './store/ScheduleDelayStore'

type ISendLaterProps = {
  store: ScheduleDelayStore
} & IScheduleDateFiledUIProps

export const ScheduleDelay = ({ store, ...props }: ISendLaterProps) => {
  return (
    <ScheduleDelayContext.Provider value={store}>
      <ScheduleDelayUI {...props} />
    </ScheduleDelayContext.Provider>
  )
}
